module.exports = __webpack_public_path__ + "img/lightspeed.10ba3653.svg";